//参考 https://github.com/ElemeFE/element/blob/dev/packages/message/src/main.js
import Vue from 'vue';
import Main from './main.vue';
import Utils from '@/global/utils.js'

let TipsConstructor = Vue.extend(Main);

let instance;
let seed = 1;

const Tips = function(options){
    if (typeof options === 'string') {
        options = {
            message: options
        };
    }
    let userOnClose = options.onClose;
    let id = 'tips_' + seed++;
    options.onClose = function(){
        Tips.close(id, userOnClose);
    };
    instance = new TipsConstructor({
        data: options
    });
    instance.id = id;
    if(Utils.isVNode(instance.message)){
        instance.$slots.default = [instance.message];
        instance.message = null;
    }
    instance.$mount();
    document.body.appendChild(instance.$el);
    return instance;
}

Tips.showError = (retcode, retmsg, speed) => {
    return Tips({
        message: `[${retcode}]${retmsg}`,
        speed: speed || 1500
    });
};

Tips.showErrorPage = (retcode, retmsg) => {
    return Tips({
        type: 'errorpage',
        retcode: retcode,
        retmsg: retmsg,
        containerClass: {
            'error-page': true
        }
    });
};

Tips.showLoading = (message) => {
    return Tips({
        type: 'loading',
        message: message || ''
    });
};

Tips.hideLoading = (instance) => {
    instance.close();
};

Tips.showOptBox = (options) => {
    return Tips({
        type: 'optbox',
        message: options.message || '',
        button: options.button || null
    });
};

Tips.showSelectBox = (options) => {
    return Tips({
        type: 'select',
        selectBox: options
    });
};


export default Tips